export enum CatNum {
  DELSTD = 'DELSTD',
  DELRGB = 'DELRGB',
  INSRGB = 'INSRGB',
  DISRGB = 'DISRGB',
}

export enum Status {
  F = 'F',
  C = 'C',
}

export enum Description {
  Delivery = 'Delivery',
  Installation = 'Installation',
  Disposal = 'Disposal',
  Recycling = 'Recycling',
}

export interface Service {
  charge_type: number;
  cat_num?: string | CatNum;
  status: Status;
  description: Description;
  price_net?: number;
  price_gross: number;
  charge_customer: boolean;
}

export const Service = undefined;
